import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { Container, Row, Col } from "react-bootstrap";
import HelmetWrapper from "../../HelmetWrapper";
import TriggerForm from "../../components/trigger-system/triggers/TriggerForm";
import CommonStructured from "../../components/common-components/CommonStructured";
import CmnFilters from "../../components/lead-management/common/CmnFilters";
import TriggerListings from "../../components/trigger-system/triggers/TriggerListings";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";
import { selectUser } from "../../components/auth/auth.selector";
import { fetchTriggersData } from "../../redux/plans-reducers/plansSlice";
import "../../styles/trigger-system/triggers.css";
import TriggerDays from "../../components/trigger-system/triggers/TriggerDays";

const Triggers = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);

  const { triggers, triggersLoading, triggersError } = useSelector(
    (state) => state.plans
  );

  // Pagination states
  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);

  // Filter states
  const iniAllFilter = {
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  // Modal states
  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  // Filter handling functions
  const onClickSearch = () => {
    setIsPage(0);
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  const getTriggersData = (filters) => {
    dispatch(
      fetchTriggersData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  useEffect(() => {
    getTriggersData(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
    }));
  }, [isPage, pageLimit]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Trigger System">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Detail Modal"
          ariaHideApp={false}>
          <div
            className={`createNewCTOModalContainer ${
              modValues.modName === "add" || modValues.modName === "edit"
                ? "bg-white"
                : ""
            }`}>
            <ModalHeadAndClose
              title={
                modValues.modName === "add" || modValues.modName === "edit"
                  ? `${modValues.modName} Trigger`
                  : modValues.modName === "offer-days"
                  ? `${modValues.rowData?.type}(${modValues.rowData?.category})`
                  : modValues.modName?.replace(/_/g, " ")
              }
              onClose={onCloseModal}
            />

            {modValues.modName === "description" ? (
              <div className="discussionModalMessage mt30">
                <p className="message">
                  {modValues.rowData?.description || "No Content Available"}
                </p>
              </div>
            ) : modValues.modName === "add" || modValues.modName === "edit" ? (
              <TriggerForm
                isEdit={modValues.modName === "edit"}
                rowData={modValues.rowData}
                closeModal={onCloseModal}
                userInfoData={userInfoData}
                callFunction={() => getTriggersData(filters)}
              />
            ) : modValues.modName === "offer-days" ? (
              <TriggerDays
                userInfoData={userInfoData}
                rowData={modValues.rowData}
                closeModal={onCloseModal}
              />
            ) : null}
          </div>
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Triggers"}
              isReload={() => getTriggersData(filters)}
              createBtnTxt={"+ Add New Trigger"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "add",
                }))
              }
            />
          </Col>
        </Row>

        {/* <Row>
          <Col>
            <CmnFilters
              from="triggers"
              userInfoData={userInfoData}
              searchFilterApplied={searchFilterApplied}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              onClickReset={onResetFilters}
              isLoading={centralisedPlanCategoriesLoading}
              searchPlaceHolder="Search by category name..."
            />
          </Col>
        </Row> */}

        <Row>
          <Col>
            <TriggerListings
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
              userInfoData={userInfoData}
              callFunction={() => getTriggersData(filters)}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default Triggers;
